import { useEffect, useRef, useCallback } from 'react';

// Construir URL do WebSocket a partir da URL do backend
const getWebSocketUrl = () => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
  // Substituir http/https por ws/wss e adicionar /api para o ingress
  return backendUrl.replace('https://', 'wss://').replace('http://', 'ws://') + '/api/ws';
};

export function useWebSocket(onMessage, dependencies = []) {
  const wsRef = useRef(null);
  const reconnectTimeoutRef = useRef(null);
  const pingIntervalRef = useRef(null);
  const wsUrl = getWebSocketUrl();

  const connect = useCallback(() => {
    try {
      // Fechar conexão anterior se existir
      if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        return;
      }

      console.log('[App WS] Conectando ao WebSocket:', wsUrl);
      wsRef.current = new WebSocket(wsUrl);

      wsRef.current.onopen = () => {
        console.log('[App WS] WebSocket conectado');
        // Iniciar ping para manter conexão viva
        pingIntervalRef.current = setInterval(() => {
          if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
            wsRef.current.send('ping');
          }
        }, 30000); // Ping a cada 30 segundos
      };

      wsRef.current.onmessage = (event) => {
        if (event.data === 'pong') {
          return; // Ignorar pong
        }
        try {
          const data = JSON.parse(event.data);
          console.log('[App WS] Mensagem recebida:', data);
          if (onMessage && data.type) {
            onMessage(data);
          }
        } catch (e) {
          // Ignorar mensagens que não são JSON (pode ser do hot reload)
        }
      };

      wsRef.current.onclose = (event) => {
        console.log('[App WS] WebSocket desconectado, reconectando em 3s...');
        clearInterval(pingIntervalRef.current);
        // Tentar reconectar após 3 segundos
        reconnectTimeoutRef.current = setTimeout(() => {
          connect();
        }, 3000);
      };

      wsRef.current.onerror = (error) => {
        console.error('[App WS] WebSocket erro:', error);
      };
    } catch (error) {
      console.error('[App WS] Erro ao conectar WebSocket:', error);
      // Tentar reconectar após 3 segundos
      reconnectTimeoutRef.current = setTimeout(() => {
        connect();
      }, 3000);
    }
  }, [wsUrl, onMessage]);

  useEffect(() => {
    connect();

    return () => {
      clearTimeout(reconnectTimeoutRef.current);
      clearInterval(pingIntervalRef.current);
      if (wsRef.current) {
        wsRef.current.close();
      }
    };
  }, [connect, ...dependencies]);

  return wsRef.current;
}
